<script>
    import {router} from "../lib/Router/Router.svelte";
    import app from "../stores/app";
    import user from "../stores/user";
    import clocking from "../stores/clocking";
    import {clickOutside} from "../lib/clickOutside";
    import {setFocusTo} from "../lib/lib";
    import Icon from "./Icon.svelte";
    import AppIcon from "./icons/AppIcon.svelte";
    import UserInitials from "./controls/UserInitials.svelte";

    let showUserDropdown = false;
    let clockingTaskTime = null;
    let viewBy = {};
    let currentUserId = $user.id;
    let showViewByDropdown = false;

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            closeUserDropdown();
            closeViewByDropdown();
        }
    }

    const setTheUsers = () => {
        viewBy = {}
        viewBy[$user.id] = {
            name: $user.name,
            color: $user.color
        };
        viewBy[0] = {
            name: 'Δημόσιο',
        };
    }

    const logOut = () => {
        user.clearToken();
        router.go('/app')();
    }

    const toggleMenu = () => {
        $app.menuExpanded = $app.menuExpanded > 0 ? 0 : 2;
    }

    const toggleUserDropdown = () => {
        if (!showUserDropdown) {
            showUserDropdown = true;
            document.addEventListener('keydown', handleEscapeKey);
        } else {
            closeUserDropdown();
        }
    }

    const closeUserDropdown = () => {
        showUserDropdown = false;
        document.removeEventListener('keydown', handleEscapeKey);
    }

    const toggleViewByDropdown = () => {
        if (!showViewByDropdown) {
            showViewByDropdown = true;
            document.addEventListener('keydown', handleEscapeKey);
        } else {
            closeUserDropdown();
        }
    }

    const closeViewByDropdown = () => {
        showViewByDropdown = false;
        document.removeEventListener('keydown', handleEscapeKey);
    }

    const selectViewBy = (id) => {
        app.setViewBy(id);
        closeViewByDropdown();
    }

    const openClockingTask = () => {
        if ($app.page === 'task') {
            setFocusTo('clockingTaskName');
        } else {
            $clocking.showTaskModal = true;
        }
    }

    $: if ($clocking.task.id > 0) {
        clockingTaskTime = clocking.getDurationString();
    } else {
        clockingTaskTime = null;
    }

    setTheUsers();

    $: if (currentUserId != $user.id) {
        currentUserId = $user.id;
        setTheUsers();
    }
</script>

<header>
    <div class="content">
        <div class="content-left">
            <div class="menu-icon" on:click="{ toggleMenu }">
                <Icon name="menu" size="24"/>
            </div>
            <div class="brand">
                SourceMan
            </div>
        </div>
        <div class="content-right gap-2">
            {#if $user.id > 0}
                <div class="content-item dropdown-container">
                    <button class="btn-reset d-flex align-items-center gap-1" on:click="{ toggleViewByDropdown }">
                        <UserInitials user={viewBy[$app.viewBy]} sm/> {viewBy[$app.viewBy].name}
                    </button>
                    {#if showViewByDropdown}
                        <ul class="dropdown right" use:clickOutside
                            on:click_outside="{ closeViewByDropdown }">
                            {#each Object.keys(viewBy) as key}
                                <li class="dropdown-item d-flex align-items-center gap-1 pointer"
                                    on:click="{ () => selectViewBy(key) }">
                                    <UserInitials user={viewBy[key]} sm/>
                                    {viewBy[key].name}
                                </li>
                            {/each}
                        </ul>
                    {/if}
                </div>
            {/if}
            {#if clockingTaskTime}
                <div class="content-item">
                    <div class="clocking-task" on:click={ openClockingTask }>
                        <div class="icon">
                            <AppIcon icon="clock"/>
                        </div>
                        { clockingTaskTime }
                    </div>
                </div>
            {/if}
            <div class="content-item" on:click={ () => $app.todoExpanded = !$app.todoExpanded }>
                <div class="button">
                    <AppIcon icon="check-circle" size="22" strokeWidth="2"/>
                    {#if $app.todos > 0}
                        <div class="badge">{ $app.todos }</div>
                    {/if}
                </div>
            </div>
            {#if $user.id > 0}
                <div class="content-item dropdown-container me-3" on:click="{ toggleUserDropdown }">
                    <UserInitials user={$user} xl pointer/>
                    {#if showUserDropdown}
                        <ul class="dropdown right" use:clickOutside
                            on:click_outside="{ closeUserDropdown }">
                            <li class="p-3">
                                <div class="fs-6">{ $user.name }</div>
                                <div class="text-muted">{ $user.email }</div>
                            </li>
                            <li class="separator"></li>
                            <li class="dropdown-item pointer" on:click="{ logOut }">
                                Αποσύνδεση
                            </li>
                        </ul>
                    {/if}
                </div>
            {/if}
        </div>
    </div>
</header>

<style>
    header {
        position: fixed;
        display: flex;
        align-items: center;
        height: var(--header-height);
        background: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .08);
        width: 100%;
        z-index: 9000;
    }

    header .content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    }

    header .brand {
        color: #6a6c6f;
        font-weight: bold;
        font-size: 1.2rem;
    }

    header .menu-icon {
        color: #333;
        background: #ccc;
        padding: 5px 10px;
        cursor: pointer;
    }

    @media (min-width: 1025px) {
        header .menu-icon {
            display: none;
        }
    }

    .content-left, .content-right {
        display: flex;
        align-items: center;
    }

    .content-left {
        padding-left: 20px;
    }

    .content-item {
        color: #5d5a68;
    }

    .content-item .button {
        position: relative;
        display: flex;
        cursor: pointer;
        padding: 10px 10px;
        border-radius: 50%;
    }

    .content-item .button:hover {
        background: #f1f1f3;
    }

    .content-item .button .badge {
        position: absolute;
        right: 0px;
        top: 0px;
        background: #ea5455;
        border-radius: 50%;
        display: flex;
        font-weight: 400;
        padding: 2px;
        width: 18px;
        height: 18px;
        align-items: center;
        justify-content: center;
    }

    .content-item > .clocking-task {
        position: relative;
        line-height: 1;
        background: #f1f1f3;
        border-radius: 20px;
        cursor: pointer;
        padding: 5px 10px 5px 25px;
        margin: 0 20px;
    }

    .content-item > .clocking-task .icon {
        position: absolute;
        top: 50%;
        left: 5px;
        transform: translateY(-50%);
    }
</style>